<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item" aria-current="page">
                <router-link to="/stockout">{{$t('stock_out_list')}}</router-link>
            </li>
            <li class="breadcrumb-item" aria-current="page">{{title}} <span v-if="stockout.Num">[{{stockout.Num}}]</span></li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="save"><i class="fa fa-floppy-o"></i> {{$t('save')}}</button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('branch')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="stockout.BranchId">
                                        <option v-for="ret in branchs" :value="ret.Id" :key="ret.Id">{{ ret.Name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="label-control blue">{{$t('stock_out_name')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="stockout.EmployeeId">
                                        <option value=""></option>
                                        <option v-for="ret in employees" :value="ret.Id" :key="ret.Id">{{ ret.KhmerName }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('code')}}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="stockout.Num" readonly/>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="label-control blue">{{$t('date')}}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="stockdate"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('driver')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="stockout.DriverId">
                                        <option value=""></option>
                                        <option v-for="ret in employees" :value="ret.Id" :key="ret.Id">{{ ret.KhmerName }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="label-control blue">{{$t('customer')}}</label>
                                <div>
                                    <CustomerDropdown @select="customerSelected" :value="stockout.CustomerName"></CustomerDropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br/>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="grid">
                                <thead>
                                    <tr>
                                        <th>{{$t('item_name')}}</th>
                                        <th>{{$t('description')}}</th>
                                        <th style="width: 120px;">{{$t('uom')}}</th>
                                        <th v-if="stockout.DocSource=='Sale'" style="width: 120px;">{{$t('qty')}}</th>
                                        <th style="width: 120px;">{{$t('qty_out')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret, index) in lines" :key="index">
                                        <td><AuthCompleted @select="select($event, ret)" :value="ret.ItemName"/></td>
                                        <td><input type="text" class="form-control form-control-sm" v-model="ret.Description" /></td>
                                        <td><UomDropdown :value="ret.UomName" :item_id="ret.ItemId" @select="uomChange($event, ret)"></UomDropdown></td>
                                        <td v-if="stockout.DocSource=='Sale'"><input type="number" class="form-control form-control-sm" v-model="ret.Quantity" :disabled="ret.ItemId==''" /></td>
                                        <td><input type="number" class="form-control form-control-sm" v-model="ret.QuantityOut" :disabled="ret.ItemId==''" /></td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="4">
                                            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="addLine"><i class="fa fa-plus"></i> {{ $t('add_line') }}</button>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { AuthCompleted } from '../Item';
import { CustomerDropdown } from '../Customer';
import UomDropdown from '../UOM/Dropdown';
export default {
    components: { AuthCompleted, UomDropdown, CustomerDropdown },
    data(){
        return {
            title: this.$t('request_stockout'),
            branchs: [],
            stockout: {
                CustomerId: '',
                CustomerName: '',
                DocSource: 'Manual'
            },
            lines: [{
                ItemName: '',
                ItemId: '',
                UomId: '',
                UomName: '',
                Description: '',
                Quantity: 0,
                QuantityOut: 1
            }],
            employees: [],
            isCheck: false,
            stockdate: this.$now().format('YYYY-MM-DD'),
            action: 'stockout/save'
        }
    },
    created(){
        this.getBranch();
        this.getEmployee();
        var id = this.$route.params.id;
        if(id != undefined && id != null && id != ''){
            this.findById(id);
            this.title = this.$t('stock_out_update');
            this.action = 'stockout/update';
        }
    },
    methods: {
        getBranch: async function() {
            var res = await this.$api().post('branch/list', { Limit: 0 });
            if(this.$isValid(res)){
                this.branchs = res.data.Data;
            }
        },
        addLine(){
            this.lines.push({
                ItemName: '',
                ItemId: '',
                UomId: '',
                UomName: '',
                Description: '',
                Quantity: 0,
                QuantityOut: 1
            });
        },
        select(item, line){
            line.Description = item.Name;
            line.ItemId = item.Id;
            line.UomId = '';
            line.UomName = '';
        },
        save(){
            var loading = this.$loading.show();
            this.stockout.OutDateAt = this.stockdate;
            var req = {
                Header: this.stockout,
                Lines: this.lines
            };
            this.$api().post(this.action, req).then(res => {
                if(this.$isValid(res)){
                    this.$router.push('/stockout');
                }
            }).finally(function() { loading.hide(); });
        },
        findById(id){
            var loading = this.$loading.show();
            this.$api().post('stockout/find', { Id: id }).then(res => {
                if(this.$isValid(res)){
                    var data = res.data.Data;
                    this.stockout = data.StockOut;
                    this.lines = data.StockOutLines;
                }
            }).finally(function() { loading.hide(); });
        },
        uomChange(e, line){
            line.UomId = e.UomId;
            line.UomName = e.UomName;
        },
        getEmployee: async function(){
            var res = await this.$api().post('employees', { Limit: 0 });
            if(this.$isValid(res)){
                this.employees = res.data.Data;
            }
        },
        customerSelected(e){
            this.stockout.CustomerId = e.Id;
            this.StockOut.CustomerName = e.Name;
        }
    }
}
</script>
<style scoped>
    .grid{
        width: 100%;
    }
</style>